export const AI_CLERK_HOME_HERO_COPY_VARIANT = {
  CONTROL: 'control',
  TEAM_PHOTO: 'team_photo',
  FILE_RESULT: 'file_result'
} as const

export type AiClerkHomeHeroCopyVariant =
  (typeof AI_CLERK_HOME_HERO_COPY_VARIANT)[keyof typeof AI_CLERK_HOME_HERO_COPY_VARIANT]

/** 将神策三组实验值收敛到前端支持的枚举，异常值回退到现网对照组。 */
export function normalizeAiClerkHomeHeroCopyVariant(
  value: unknown
): AiClerkHomeHeroCopyVariant {
  switch (value) {
    case AI_CLERK_HOME_HERO_COPY_VARIANT.TEAM_PHOTO:
    case AI_CLERK_HOME_HERO_COPY_VARIANT.FILE_RESULT:
      return value
    default:
      return AI_CLERK_HOME_HERO_COPY_VARIANT.CONTROL
  }
}
